import { render, staticRenderFns } from "./WelfareProductDetails.vue?vue&type=template&id=1b792490&scoped=true"
import script from "./WelfareProductDetails.vue?vue&type=script&lang=js"
export * from "./WelfareProductDetails.vue?vue&type=script&lang=js"
import style0 from "./WelfareProductDetails.vue?vue&type=style&index=0&id=1b792490&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b792490",
  null
  
)

export default component.exports